// extracted by mini-css-extract-plugin
export default {"component_homepage_marketing":"homepage-marketing_component_homepage_marketing__s6ovb"};